<template>
  <div id="PreOrderTripDetail">
    <v-dialog persistent fullscreen scrollable v-model="dialog">
    <v-card flat>
      <v-card-title style="word-break: break-word">Trip Detail<v-spacer/>
        <v-btn icon @click="closeDialog"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-progress-linear :active="queryLoading" :indeterminate="true"/>
      <v-card-text>
      <v-tabs centered v-model="tab">
        <v-tabs-slider></v-tabs-slider>
        <v-tab :href="`#tab-${index}`" :key="index" class="text-capitalize" style="letter-spacing: 0px"
               v-for="(tab,index) in tabs">{{ tab.name }}
          <v-icon>{{ tab.icon }}</v-icon>
        </v-tab>
        <v-tab-item :key="index" :value="`tab-${index}`" v-for="(tab,index) in tabs">
          <template v-if="tab.id===1 && trip">
            <v-row class="px-16">
              <v-col class="d-flex align-center justify-space-between" cols="12">
                <div>
                  <h3 class="font-weight-medium">{{ trip.tripId ? trip.tripId : '-' }}</h3>
                  <div>Route Name: {{trip.Route.name}}</div>
                  <div>Pilot Salesman: {{trip.CreatedBy.name}}</div>
                </div>
                <div class="text-right">
                 <!-- <v-btn @click="downloadTripBills" class="grey lighten-3 text--primary ml-2 mb-1 elevation-0" icon>
                    <v-icon>mdi-arrow-down</v-icon>
                  </v-btn>
                  <v-btn @click="startUnloadTrip" :disabled="['UNLOADED'].includes(trip.status)"
                         class="grey lighten-3 text--primary ml-2 mb-1 elevation-0" rounded>
                    {{ ['UNLOADED'].includes(trip.status) ? trip.status : 'UNLOAD' }}
                  </v-btn> -->
                  <v-chip label outlined :color="IDS.TripStatusColor[trip.statusId]">{{trip.TripStatus.title}}</v-chip>
                  <v-menu offset-y v-if="[IDS.TripStatus.Completed, IDS.TripStatus.Dispatched].includes(trip.statusId)">
                    <template v-slot:activator="{ on }"><v-btn color="primary" depressed dark v-on="on" class="ml-2">Manage Status</v-btn></template>
                    <v-list>
                      <v-list-item v-for="(st, index) in statusOptions[trip.statusId]" :key="index" @click="$emit('openStatusMenu', {...trip, selectedStatusId:st.id})">
                        <v-list-item-title>{{ st.name }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <div class="mt-2">Created On: {{dateTimeFilter(trip.created_at)}}</div>
                  <div>Updated On: {{dateTimeFilter(trip.updated_at)}}</div>
                </div>
              </v-col>
             <!-- <v-col cols="4">
                <div class="total-sales text-center py-8 rounded-lg">
                  <h2 class="font-weight-medium mb-3">₹
                    {{ calculateTotalSales.toFixed(2) }}</h2>
                  <span>Total Sales</span>
                </div>
              </v-col>
              <v-col cols="4">
                <div class="total-Collection text-center py-8 rounded-lg">
                  <h2 class="font-weight-medium mb-3">₹
                    {{
                      trip.CreditDebit_aggregate.aggregate.sum.amount
                          ? trip.CreditDebit_aggregate.aggregate.sum.amount.toFixed(2) : 0
                    }}
                  </h2>
                  <span>Total Collection</span>
                </div>
              </v-col>
              <v-col cols="4">
                <div class="total-expense text-center py-8 rounded-lg">
                  <h2 class="font-weight-medium mb-3">₹
                    {{ calculateExpense(trip.Expense).toFixed(2) }} </h2>
                  <span>Expenses <span @click="expenseDetailDialog=true" class="blue--text"
                                       style="cursor: pointer;font-size: 14px" v-if="calculateExpense(trip.Expense)">(Detail)</span></span>
                </div>
              </v-col> -->

              <v-col cols="4">
                <div class="total-expense text-center py-8 rounded-lg">
                  <h2 class="font-weight-medium mb-3">{{ countOfShops }}/{{ trip.TripDestinations.length }}</h2>
                  <span class="grey--text">Store Visited</span>
                </div>
              </v-col>
              <v-col cols="4">
                <div class="total-sales text-center py-8 rounded-lg">
                  <h2 class="font-weight-medium mb-3">{{ trip.Order_aggregate.aggregate.count }}/{{ countOfShops }}</h2>
                  <span class="grey--text">Orders Given</span>
                </div>
              </v-col>
              <v-col cols="4">
                <div class="total-Collection text-center py-8 rounded-lg">
                  <h2 class="font-weight-medium mb-3">₹ {{ trip.Order_aggregate.aggregate.sum.finalPrice || 0 }} </h2>
                  <span class="grey--text">Order Amount</span>
                </div>
              </v-col>

              <template v-if="lastCheckedIn">
                <v-col class="mt-3" cols="6">
                  <h3 class="mb-3 grey--text font-weight-medium">Current Location Map</h3>
                  <div class="rounded-lg grey overflow-hidden">
                    <GmapMap
                        :center="trip.GPSTracking.length?{lat:trip.GPSTracking[0].lat, lng:trip.GPSTracking[0].long}:{lat:0,lng:0}"
                        :zoom="17" style="width: 100%; height: 200px">
                      <GmapMarker :clickable="true" :draggable="true"
                                  :position="trip.GPSTracking.length?{lat:trip.GPSTracking[0].lat, lng:trip.GPSTracking[0].long}:{lat:0,lng:0}"/>
                    </GmapMap>
                  </div>
                </v-col>
                <v-col class="mb-3 mt-3 px-3" cols="6">
                  <div class="text-left">
                    <h3 class="mb-3 grey--text font-weight-medium">Last CheckIn</h3>
                    <div class="d-flex">
                      <v-icon class="mr-2" size="22">mdi-map-marker</v-icon>
                      <h2 class="font-weight-medium">{{ lastCheckedIn.shopName }} |
                        {{ dateTimeFilter(lastCheckedIn.checkInTime) }}</h2>
                    </div>
                  </div>
                </v-col>
              </template>
              <template v-else>
                <v-col class="mt-3" cols="12">
                  <h3 class="mb-3 grey--text font-weight-medium">No Checked - In yet at any shop.</h3>
                </v-col>
              </template>
            </v-row>
          </template>
          <template v-if="tab.id===2 && trip">
            <div class="px-16 mt-8">
              <v-row class="mb-3 justify-center align-center">
                <v-col class="pa-0 ml-3">
                  <span class="font-weight-medium text--primary ">{{ countOfShops }} Stores Visited</span>
                  <span class="ml-3 text-left grey--text">{{
                      trip.TripDestinations.length - countOfShops
                    }} Remaining</span>
                </v-col>
                <v-spacer></v-spacer>
                <v-btn @click="downloadTripBills" class="grey lighten-3 text--primary ml-2 mb-1 elevation-0"
                       rounded>Download <v-icon>mdi-arrow-down</v-icon></v-btn>
              </v-row>
              <v-divider></v-divider>
              <v-timeline dense :key="index" v-for="(timeline, index) in trip.TripDestinations">
                <v-timeline-item color="warning" fill-dot icon="mdi-storefront-outline" icon-color="black">
                  <v-card @click="openTripSalesOrder(timeline)" class="elevation-0 grey lighten-4 px-5 py-3">
                    <v-card-text>
                      <v-row justify="space-between">
                        <v-col class="pa-0 mb-2" cols="12">
                          <h3 class="font-weight-medium black--text"> {{ timeline.shopName }} </h3>
                        </v-col>
                        <v-col class="pa-0 mb-3" cols="12">
                          <v-chip label outlined small>{{ statusFormatter(timeline.status) }}</v-chip>
                        </v-col>
                        <v-col class="pa-0 mb-3" cols="12" v-if="timeline.notes">
                          <v-chip small>{{ timeline.notes }}</v-chip>
                        </v-col>
                        <v-col class="pa-0" cols="auto">
                          <span class="caption">Check-In</span>
                          <div>{{ timeFilter(timeline.checkInTime) }}</div>
                        </v-col>
                        <v-col class="pa-0" cols="auto">
                          <span class="caption">Duration</span>
                          <div>{{ timeline.timeSpent ? getTimeSpent(timeline.timeSpent) : '00:00' }} M</div>
                        </v-col>
                        <v-col class="pa-0" cols="auto">
                          <div class="caption">Check-Out</div>
                          <div>{{ timeFilter(timeline.checkOutTime) }}</div>
                        </v-col>
                        <v-col class="pa-0" cols="auto">
                          <div class="caption">Last Visited</div>
                          <div>{{ dateFilter(timeline.lastVisitedDate) }}</div>
                        </v-col>
                        <v-col class="pa-0" cols="auto">
                          <div class="caption">Order Amount</div>
                          <div><span class="text-body-1">₹</span>
                            {{ timeline.Order ? timeline.Order.finalPrice.toFixed(2) : 0 }}
                          </div>
                        </v-col>
                       <!-- <v-col class="pa-0" cols="auto">
                          <div class="caption">Paid</div>
                          <h3 class="green--text"><span class="text-body-1">₹</span>
                            {{ timeline.Order ? timeline.Order.colloectedAmount.toFixed(2) : 0 }}</h3>
                        </v-col> -->
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-timeline-item>
                <v-timeline-item class="pb-0" hide-dot>
                  <div class="text-center d-flex justify-center" v-if="index+1<trip.TripDestinations.length">
                    <v-icon class="mr-2" size="18">mdi-clock-time-three-outline</v-icon>
                    On way -{{ calculateTime(timeline.checkOutTime, trip.TripDestinations[index + 1].checkInTime) }} Min
                  </div>
                </v-timeline-item>
              </v-timeline>
            </div>
          </template>
          <template v-if="tab.id===3 && trip">
            <v-card flat>
              <v-card-title>
                <v-row>
                  <v-col class="d-flex align-center justify-space-between">
                    <div>Products Ordered ({{productsGrouped.length}})</div>
                    <v-btn @click="downloadTripProducts" class="grey lighten-3 text--primary ml-2 mb-1 elevation-0"
                           rounded>Download <v-icon>mdi-arrow-down</v-icon></v-btn>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-data-table :headers="stockHeaders" :items="productsGrouped" disable-sort hide-default-footer
                              :footer-props="{itemsPerPageOptions:[25,50,100]}" :items-per-page="25">
                  <template v-slot:item.product="{item}">
                    <div class="py-5 d-flex">
                      <div class="text-center">
                        <v-img :src="imgWpx(item.image,200)" width="50" class="mx-auto"></v-img>
                        <v-chip class="mt-2 white--text" label small
                                :style="`background-color: ${packageColor[item.packageType]}`">{{ item.packageType }}
                        </v-chip>
                      </div>
                      <div>
                        <div :style="{color:item.colorCode}">{{ item.displayName }}</div>
                        <p class="text-caption font-italic grey--text text--darken-2">{{ item.noOfPieceInBox }} Pieces in {{item.containerType}}</p>
                      </div>
                    </div>
                  </template>
                  <template v-slot:item.quantity="{item}">
                   <span>{{item.boxes}} {{item.containerType}}{{ item.boxes>1?'es':''}}</span> <br>
                   <span>{{item.pieces}} Piece{{ item.pieces>1?'s':''}}</span>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </template>
          <template v-if="tab.id===4 && trip">
            <LiveTripRoute></LiveTripRoute>
          </template>
        </v-tab-item>
      </v-tabs>
      </v-card-text>
    </v-card>
    </v-dialog>

    <v-dialog max-width="800" persistent v-if="expenseDetailDialog" v-model="expenseDetailDialog">
      <v-card>
        <v-card-title style="word-break: break-word">Expense Detail</v-card-title>
        <v-card-text>
          <v-data-table :headers="expenseDetailHeaders" :items="trip.Expense" :items-per-page="15" disable-sort
                        hide-default-footer>
            <template v-slot:item.title="{item}">{{ item.Expenses.title }}</template>
            <template v-slot:item.amount="{item}">{{ item.amount.toFixed(2) }}</template>
            <template v-slot:item.createdOn="{item}">{{ dateTimeFilter(item.created_at) }}</template>
            <template v-slot:item.note="{item}">{{ item.note }}</template>
            <template v-slot:item.attachments="{item}">
              <v-btn icon @click="previewAttachments(item.ExpenseAttachments)">
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions class="mt-16">
          <v-spacer></v-spacer>
          <v-btn @click.native="expenseDetailDialog=false" class="error--text" dark outlined>Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog max-width="900" v-if="expenseAttachmentDialog" v-model="expenseAttachmentDialog">
      <v-card style="height: 75vh" class="overflow-hidden">
        <v-card-title>
          <h6 class="text-h6">Attachments</h6>
          <v-spacer></v-spacer>
          <v-btn @click="expenseAttachmentDialog = false" icon="mdi-close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-carousel height="auto">
          <v-carousel-item v-for="(item,index) in expenseAttachments" :key="index">
            <img :src="imgWpx(item.image)" style="object-fit: contain; height: calc(75vh - 62px)" alt="EXPENSE"
                 class="d-block mx-auto"/>
          </v-carousel-item>
        </v-carousel>
      </v-card>
    </v-dialog>
    <v-dialog scrollable fullscreen persistent v-if="unloadTripDialog" v-model="unloadTripDialog">
      <v-card>
        <v-card-title>Unload Trip</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col cols="8">
              <v-data-table fixed-header style="height: calc(100vh - 150px); overflow-y: auto"
                            :headers="unloadStockHeaders" :items="productsGrouped" :items-per-page="15" disable-sort
                            hide-default-footer>
                <template v-slot:header.check="{  }">
                  <v-checkbox @change="toggleProductSelectionAll($event)" dense hide-details indeterminate
                              v-model="allProductSelected"></v-checkbox>
                </template>
                <template v-slot:item.productName="{item}">
                  <div class="my-3 d-flex">
                    <div>
                      <v-img class="mx-auto" :src="imgWpx(item.products[0].Product.image, 200)" width="50"></v-img>
                      <v-chip class="mt-2 white--text font-weight-medium" label x-small
                              :style="`background-color: ${packageColor[item.products[0].Product.packageType]}`">
                        {{ item.products[0].Product.packageType }}
                      </v-chip>
                    </div>
                    <div class="ml-5">
                      <div :style="{color:item.products[0].Product.colorCode}"> {{ item.products[0].Product.displayName }}
                        ({{ item.products[0].Product.weight }} gm)
                      </div>
                      <p class="text-caption mb-0 grey--text text--darken-2 font-italic">
                        {{ item.products[0].Product.bunchKg }} Pieces in Box</p>
                    </div>
                  </div>
                </template>
                <template v-slot:item.openingStock="{item}">
                  <div>{{ item.products[0].initialQty }} {{ item.products[0].Unit.unit }}<br/>
                    {{ item.products[1].initialQty }} {{ item.products[1].Unit.unit }}
                  </div>
                </template>
                <template v-slot:item.soldStock="{item}">
                  <div>
                    {{ calculateSoldStock(item.products)[0] }} {{ item.products[0].Unit.unit }}<br/>
                    {{ calculateSoldStock(item.products)[1] }} {{ item.products[1].Unit.unit }}
                  </div>
                </template>
                <template v-slot:item.closingStock="{item}">
                  <div>{{ item.products[0].currentQty }} {{ item.products[0].Unit.unit }}<br/>
                    {{ item.products[1].currentQty }} {{ item.products[1].Unit.unit }}
                  </div>
                </template>
                <template v-slot:item.check="{item}">
                  <v-checkbox @change="toggleProductSelection($event,item)" class="ma-0 pa-0" dense
                              hide-details v-model="item.selected"></v-checkbox>
                </template>

                <!--<template v-slot:footer>-->
                <!--<div class="text-right mt-2 " style="font-size: 16px"><span>TOTAL STOCK AMOUNT</span>-->
                <!--<span class="font-weight-bold"><span class="body-1">₹</span> {{ countTotalStockAmount }}</span>-->
                <!--</div>-->
                <!--</template>-->
              </v-data-table>
            </v-col>
            <v-col cols="4" class="pt-1">
              <v-row>
                <v-col class="text-h6">
                  <div class="d-flex" style="font-size: 16px">
                    <span>Total Stock Amount</span>
                    <v-spacer></v-spacer>
                    <span class="font-weight-bold"><span class="body-1">₹</span> {{ countTotalStockAmount.toFixed(2) }}</span>
                  </div>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <div class="d-flex justify-space-between order-bill my-2">
                <span class="grey--text">Total Sales</span>
                <span class="grey--text"><span class="body-2">₹</span> {{ calculateTotalSales.toFixed(2) }}</span>
              </div>
              <div class="d-flex justify-space-between order-bill my-2">
                <span class="grey--text">Total Collection</span>
                <span class="grey--text"><span class="body-2">₹</span> {{
                    trip.CreditDebit_aggregate.aggregate.sum.amount
                        ? trip.CreditDebit_aggregate.aggregate.sum.amount.toFixed(2)
                        : 0
                  }}</span>
              </div>
              <div class="d-flex justify-space-between order-bill my-2">
                <span class="grey--text">Total Expenses</span>
                <span class="grey--text"><span class="body-2">₹</span> {{
                    calculateExpense(trip.Expense).toFixed(2)
                  }}</span>
              </div>
              <div class="d-flex justify-space-between order-bill my-2">
                <span class="grey--text">Final Amount</span>
                <span class="grey--text"><span class="body-2">₹</span> {{
                    ((trip.CreditDebit_aggregate.aggregate.sum.amount
                        ? trip.CreditDebit_aggregate.aggregate.sum.amount
                        : 0) - (calculateExpense(trip.Expense))).toFixed(2)
                  }}</span>
              </div>

              <!--<v-row class="pl-5 text-right">-->
              <!--<v-col cols="12">-->
              <!--<div>-->
              <!--<span class="text-h6">TOTAL SALES </span>-->
              <!--<span class="title">₹{{ calculateTotalSales.toFixed(2) }}</span>-->
              <!--</div>-->
              <!--</v-col>-->
              <!--<v-col cols="12">-->
              <!--<div>-->
              <!--<span class="text-h6">TOTAL COLLECTION </span>-->
              <!--<span-->
              <!--class="title">₹{{-->
              <!--trip.CreditDebit_aggregate.aggregate.sum.amount-->
              <!--? trip.CreditDebit_aggregate.aggregate.sum.amount.toFixed(2)-->
              <!--: 0-->
              <!--}}</span>-->
              <!--</div>-->
              <!--</v-col>-->
              <!--<v-col cols="12">-->
              <!--<div><span class="text-h6">TOTAL EXPENSES </span>-->
              <!--<span class="title"> ₹{{ calculateExpense(trip.Expense).toFixed(2) }}</span>-->
              <!--</div>-->
              <!--</v-col>-->
              <!--<v-col cols="12">-->
              <!--<div class="green&#45;&#45;text"><span class="text-h6">FINAL AMOUNT </span>-->
              <!--<span-->
              <!--class="title">₹{{-->
              <!--((trip.CreditDebit_aggregate.aggregate.sum.amount-->
              <!--? trip.CreditDebit_aggregate.aggregate.sum.amount-->
              <!--: 0) - (calculateExpense(trip.Expense))).toFixed(2)-->
              <!--}}</span>-->
              <!--</div>-->
              <!--</v-col>-->
              <!--</v-row>-->

            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn @click.native="unloadTripDialog=false" class="white elevation-0">Cancel</v-btn>
          <v-btn :disabled="!allProductSelected || trip.status==='UNLOADED WITH OPENING'"
                 @click="confirmUnloadTrip(true)"
                 class="accent darken-1 elevation-0">
            UNLOAD WITH OPENING
          </v-btn>
          <v-btn :disabled="!allProductSelected" @click="confirmUnloadTrip(false)" class="primary elevation-0">UNLOAD
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
   <!-- <TripOrderDetails :tripDestinationId="tripDestinationId" :tripId="tripId" :tripOrderDialog="tripOrderDialog"
                      @cancel="tripOrderDialog=false" v-if="tripOrderDialog"></TripOrderDetails> -->
    <SalesOrderDetail :dialog.sync="tripOrderDialog" :orderId="orderId"/>
    <ConfirmationDialog :confirmationMessage="confirmMsg" @close="confirmationDialog=false"
                        @confirm="unloadTrip" v-if="confirmationDialog"></ConfirmationDialog>
  </div>
</template>

<script>
import { SUBSCRIBE_LAST_CHECKIN_TRIP } from '../../graphql/subscriptions/Trips'
import { UNLOAD_TRIP_STOCK, UPDATE_TRIP_STATUS } from '@/graphql/mutations/Trips'
import moment from 'moment'
import SalesOrderDetail from "../SalesOrders/SalesOrderDetail";
import LiveTripRoute from '@/components/TripManagement/LiveTripRoute'
import Constants from '../../Constants/Constants'
import {IDS} from "../../Constants/IDS";
import ConfirmationDialog from '@/components/Common/ConfirmationDialog'
import {SUBSCRIBE_PRE_ORDER_TRIP_DETAILS_BY_ID} from "../../graphql/subscriptions/PreOrderTrips";
// function groupItemBy (array, property) {
//   var hash = {}, props = property.split('.')
//   for (var i = 0; i < array.length; i++) {
//     var key = props.reduce(function (acc, prop) {
//       return acc && acc[prop]
//     }, array[i])
//     if (!hash[key]) hash[key] = []
//     hash[key].push(array[i])
//   }
//   return hash
// }
export default {
  name: 'PreOrderTripDetail',
  components: { ConfirmationDialog, LiveTripRoute, SalesOrderDetail },
  props: {
    dialog: {default: false},
    tripId: { default: null },
  },
  data () {
    return {
      user: JSON.parse(localStorage.user), tab: 'tab-0', withOpening: false, IDS,
      tabs: [
        { id: 1, name: 'Basic Information' }, { id: 2, name: 'Trip History' }, { id: 3, name: 'Products' },
        { id: 4, name: 'Live Route' }],
      trip: null, tripDestinationId: null,
      productsGrouped: [], unloadTripDialog: false, allProductSelected: false,
      tripOrderDialog: false, expenseDetailDialog: false, lastCheckedIn: null,
      confirmMsg: '', confirmationDialog: false,
      stockHeaders: [
        { text: 'Products', value: 'product' }, { text: 'Quantity', value: 'quantity' },
      ],
      unloadStockHeaders: [
        { text: 'Product', value: 'productName' }, { text: 'Opening Stock', value: 'openingStock' },
        { text: 'Sold Stock', value: 'soldStock' }, { text: 'Closing Stock', value: 'closingStock' },
        { text: 'Check', value: 'check' },
      ],
      expenseDetailHeaders: [
        { text: 'Type', value: 'title' }, { text: 'Amount', value: 'amount' },
        { text: 'Created On', value: 'createdOn' }, { text: 'Note', value: 'note' },
        { text: 'Attachments', value: 'attachments' },
      ],
      expenseAttachmentDialog: false, expenseAttachments: [],
      packageColor: JSON.parse(localStorage.packageColor),
      statusOptions: {
        [IDS.TripStatus.Completed]: [{id:IDS.TripStatus.Dispatched, name:'Dispatched'}, {id:IDS.TripStatus.Delivered, name:'Delivered'}],
        [IDS.TripStatus.Dispatched]: [{id:IDS.TripStatus.Delivered, name:'Delivered'}],
      },
      queryLoading: true,
      orderId: null
    }
  },
  apollo: {
    $subscribe: {
      Trips: {
        query: SUBSCRIBE_PRE_ORDER_TRIP_DETAILS_BY_ID, fetchPolicy: 'network-only',
        variables () { return { id: this.tripId } },
        skip () { return !this.tripId },
        result ({ data, loading }) {
          if (!loading) {
            this.trip = data.Trips[0];
            let puObj = {};          //productId.unitId object
            let pObj = {};           //productId object
            this.trip.Order.forEach(o => {
              o.OrderItems.forEach(oi => {
                if(!puObj[oi.productId]) puObj[oi.productId] = {};
                puObj[oi.productId][oi.unitId] = oi.quantity + (puObj[oi.productId]?.[oi.unitId]||0)
                pObj[oi.productId] = oi.Product
              })
            });
            this.productsGrouped = Object.keys(pObj).map(id => ({...pObj[id],
                ...this.evaluateBoxesPieces(puObj[id][IDS.unitType.Box], puObj[id][IDS.unitType.Piece], pObj[id]['noOfPieceInBox'])}));
            this.queryLoading = false;
          }
        },
      },
      TripLastCheckIn: {
        query: SUBSCRIBE_LAST_CHECKIN_TRIP, fetchPolicy: 'network-only',
        variables () { return { id: this.tripId } },
        skip () { return !this.tripId },
        result ({ data, loading }) {
          if (!loading) {
            this.lastCheckedIn = data.Trips[0].TripDestinations.length ? (data.Trips[0].TripDestinations[0].checkInTime
                ? data.Trips[0].TripDestinations[0]
                : null) : null
          }
        },
      },
    },
  },
  computed: {
    countOfShops () {
      return this.trip ? this.trip.TripDestinations.filter(destination => destination.status === 'VISITED').length : 0
    },
    countTotalStockAmount () {
      let finalAmount = 0
      if (this.trip) {
        this.trip.VehicleTripStock.forEach(stock => {
          finalAmount += stock.currentQty * (Number(stock.Product.price) + Number(stock.Product.retailer))
          // if (stock.unitId === IDS.unitType.Piece) {
          //   finalAmount += stock.currentQty * stock.Product.price
          // } else if (stock.unitId === IDS.unitType.Box) {
          //   finalAmount += stock.currentQty * stock.Product.bunchPrice
          // }
        })
      }
      return finalAmount
    },
    calculateTotalSales () {
      let totalSales = 0
      this.trip.TripDestinations.forEach(shop => {
        if (shop.Order)
          totalSales += shop.Order.finalPrice
      })
      return totalSales
    },
  },
  methods: {
    confirmUnloadTrip (withOpening) {
      this.confirmationDialog = true
      this.confirmMsg = 'Are you sure, you want Unload this trip?'
      this.withOpening = withOpening
    },
    unloadTrip () {
      let self = this
      if (this.withOpening) {
        self.$apollo.mutate(
            { mutation: UPDATE_TRIP_STATUS, variables: { tripId: self.trip.id, status: IDS.TripStatus.UnloadedWithOpening } })
        self.confirmationDialog = false
        self.unloadTripDialog = false
        alert('Trip Stock Unloaded')
      } else {
        this.trip.VehicleTripStock.forEach((vehicleTripStock, index) => {
          self.trip.OrganizationStock.forEach(orgStock => {
            if (orgStock.organizationId === self.user.organizationId && vehicleTripStock.productId ===
                orgStock.productId && vehicleTripStock.unitId === orgStock.unitId) {
              self.$apollo.mutate({
                mutation: UNLOAD_TRIP_STOCK,
                variables: {
                  orgStockId: orgStock.id,
                  vehicleTripStockId: vehicleTripStock.id,
                  stockQty: orgStock.quantity + vehicleTripStock.currentQty,
                  unloadedQty: vehicleTripStock.currentQty,
                },
              })
              if (index === self.trip.VehicleTripStock.length - 1) {
                self.$apollo.mutate(
                    { mutation: UPDATE_TRIP_STATUS, variables: { tripId: self.trip.id, status: IDS.TripStatus.Unloaded } })
                self.confirmationDialog = false
                self.unloadTripDialog = false
                alert('Trip Stock Unloaded')
              }
            }
          })
        })
      }
    },
   /* openTripOrder(tripDestination){
      if (tripDestination.Order) {
        this.tripDestinationId = tripDestination.shopId
        this.tripOrderDialog = true
      }
    }, */
    openTripSalesOrder(tripDestination){
      if(tripDestination.Order) {
        this.orderId = tripDestination.Order.id;
        this.tripOrderDialog = true;
      }
    },
    startUnloadTrip () { this.unloadTripDialog = true },
    toggleProductSelection (val, productSelection) {
      productSelection.selected = val
      this.allProductSelected = !this.productsGrouped.some(element => element.selected !== true)
    },
    toggleProductSelectionAll (val) {
      this.allProductSelected = val
      this.productsGrouped.forEach(item => item.selected = val)
    },
    timeFilter (val) { return val ? moment(val).format('hh:mm A') : '-' },
    dateFilter (val) { return val ? moment(val).format('DD/MM/YYYY') : '-' },
    calculateExpense (expenses) {
      return expenses.reduce((prev, next) => parseFloat(prev) + parseFloat(next.amount), 0)
    },
    calculateTime (checkOut, checkIn) {
      return checkIn && checkOut ? moment(checkIn).diff(moment(checkOut), 'minutes') : 0
    },
    getTimeSpent (seconds) { return moment.utc(seconds * 1000).format('mm:ss') },
    downloadTripBills () {
      window.open(`${Constants.api_url}vehicleTrip/${this.trip.id}/OrderGeneratePDF`, '_blank')
    },
    downloadTripProducts () {
      window.open(`${Constants.api_url}tripOrderProductPdf/${this.trip.id}`, '_blank')
    },
    calculateSoldStock (products) {
      let soldStock = [0, 0]
      soldStock[0] = products[0].initialQty - products[0].currentQty
      soldStock[1] = products[1].initialQty - products[1].currentQty
      if (soldStock[1] < 0) {
        soldStock[1] = parseInt(products[1].Product.bunchKg) + soldStock[1]
        soldStock[0] = soldStock[0] - 1
      }
      return soldStock
    },
    previewAttachments (expense) {
      console.log(expense)
      this.expenseAttachments = expense
      this.expenseAttachmentDialog = true
      this.$forceUpdate()
    },
    evaluateBoxesPieces(boxes = 0, pieces = 0, noOfPieceInBox){
      return {boxes: (boxes+Math.floor(pieces/noOfPieceInBox)), pieces:(pieces%noOfPieceInBox) }
    },
    closeDialog(){
      this.$emit('update:dialog', false)
      this.$emit('update:tripId', false)
      this.trip = null;
      this.queryLoading = true;
    }
  },
}
</script>
